export const articleList = [
  {
    id: 1,
    title: '欧冠小组赛抽签结果出炉：死亡之组再现，皇马遭遇强敌',
    excerpt: '2026-27赛季欧冠联赛小组赛抽签仪式在摩纳哥举行，多组强强对话引人关注。皇家马德里与拜仁慕尼黑、AC米兰同组，组成名副其实的"死亡之组"。',
    content: `
      <p>2026-27赛季欧洲冠军联赛小组赛抽签仪式于本周四在摩纳哥蒙特卡洛举行。作为欧洲最高水平的俱乐部赛事，每年的抽签结果都备受全球球迷关注。</p>
      
      <h2>死亡之组再度出现</h2>
      <p>本次抽签最大的亮点莫过于D组的形成。皇家马德里作为第一档球队，抽到了第二档的拜仁慕尼黑、第三档的AC米兰以及第四档的纽卡斯尔联。四支球队均来自欧洲五大联赛，实力强劲，堪称真正的"死亡之组"。</p>
      
      <p>皇马主帅安切洛蒂在接受采访时表示："每一场欧冠比赛都不容易，但我们做好了准备。面对拜仁和米兰这样的传统豪门，我们必须拿出最好的状态。"</p>
      
      <h2>其他小组分析</h2>
      <p>A组方面，卫冕冠军曼城抽到上上签，同组对手包括波尔图、凯尔特人和贝尔格莱德红星。B组的巴塞罗那将迎战多特蒙德和埃因霍温。C组则有利物浦与国际米兰的强强对话。</p>
      
      <p>小组赛首轮将于9月12日正式打响，bob体育将持续为您带来欧冠赛事的最新赔率与深度分析。</p>
    `,
    category: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=Champions%20League%20trophy%20with%20dramatic%20stadium%20lighting%2C%20professional%20sports%20photography%2C%20dark%20background%20with%20golden%20accents%2C%20premium%20sports%20aesthetic&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-08-05',
    readTime: '8分钟',
    tags: ['欧冠', '皇马', '抽签', '死亡之组'],
  },
  {
    id: 2,
    title: 'NBA休赛期重磅交易汇总：超级巨星换队，联盟格局大洗牌',
    excerpt: '2026年NBA休赛期交易市场风起云涌，多支球队完成重磅交易，联盟竞争格局发生巨大变化。本文为您梳理今夏最值得关注的十大交易。',
    content: `
      <p>2026年NBA休赛期的交易市场比往年更加热闹。随着工资帽的调整和多支球队重建计划的启动，我们看到了一系列令人震惊的交易。</p>
      
      <h2>顶级交易回顾</h2>
      <p>最引人注目的交易当属湖人队送出三名球员和两个首轮选秀权，从雷霆队换来了场均28.5分的全明星后卫。这笔交易让湖人队的夺冠赔率瞬间跃升至联盟前三。</p>
      
      <p>此外，凯尔特人队也完成了阵容升级，通过三方交易获得了一位顶级3D球员，进一步巩固了东部霸主的地位。掘金队则保留了核心阵容，并签下两位经验丰富的老将。</p>
      
      <p>bob体育NBA新赛季夺冠赔率已全面更新，湖人、凯尔特人和掘金位列前三。您更看好哪支球队？</p>
    `,
    category: 'basketball',
    coverImage: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20court%20with%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20arena%20atmosphere%2C%20dark%20background%2C%20premium%20sports%20aesthetic&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-08-04',
    readTime: '6分钟',
    tags: ['NBA', '交易', '湖人', '凯尔特人'],
  },
  {
    id: 3,
    title: '温网男单决赛前瞻：新老天王对决，谁能笑到最后',
    excerpt: '2026年温布尔登网球锦标赛男单决赛即将上演，新生代领军人物辛纳对阵经验丰富的梅德韦杰夫，这场对决备受瞩目。',
    content: `
      <p>2026年温布尔登网球锦标赛男单决赛将于本周末在全英俱乐部中心球场举行。意大利新星辛纳将对阵俄罗斯名将梅德韦杰夫。</p>
      
      <h2>选手状态分析</h2>
      <p>辛纳本赛季状态火热，已斩获三个大师赛冠军，世界排名升至第二。他的正手进攻和发球质量在本届温网达到了新的高度。半决赛中，他以3-0横扫对手晋级。</p>
      
      <p>梅德韦杰夫则是本届赛事的黑马。尽管此前在草地赛季表现平平，但他在温网的发挥令人惊叹，连续击败了三位种子选手闯入决赛。</p>
      
      <p>bob体育赛前赔率显示辛纳略微占优（赔率1.60），但梅德韦杰夫（赔率2.40）的爆冷潜力不容忽视。</p>
    `,
    category: 'tennis',
    coverImage: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20court%20with%20green%20grass%2C%20professional%20sports%20photography%2C%20premium%20aesthetic%2C%20dramatic%20lighting%2C%20dark%20background&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-08-03',
    readTime: '5分钟',
    tags: ['温网', '网球', '辛纳', '梅德韦杰夫'],
  },
  {
    id: 4,
    title: 'LOL全球总决赛战队实力排名：LCK与LPL的巅峰对决',
    excerpt: '2026年英雄联盟全球总决赛即将开战，各大赛区战队实力分析。T1、JDG、GEN等顶尖战队谁能问鼎召唤师杯？bob体育为您带来独家前瞻。',
    content: `
      <p>2026年英雄联盟全球总决赛将在首尔举行，来自全球各大赛区的24支战队将争夺召唤师杯和超过300万美元的总奖金。</p>
      
      <h2>夺冠热门</h2>
      <p>T1战队在LCK夏季赛中以全胜战绩夺冠，Faker的指挥和Gumayusi的carry能力令人叹服。JDG则在LPL赛区延续了统治力，Knight和Ruler的双C组合无人能挡。</p>
      
      <p>bob体育夺冠赔率显示T1以2.10的赔率位居榜首，JDG以2.50紧随其后。这场中韩对决，您看好哪一方？</p>
    `,
    category: 'esports',
    coverImage: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20dramatic%20stage%20lighting%2C%20League%20of%20Legends%20championship%20atmosphere%2C%20professional%20gaming%20photography%2C%20dark%20background&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-08-02',
    readTime: '7分钟',
    tags: ['LOL', 'S赛', 'T1', 'JDG'],
  },
  {
    id: 5,
    title: '英超新赛季前瞻：六强争霸，谁能问鼎新赛季冠军',
    excerpt: '2026-27赛季英超联赛即将拉开大幕，曼城能否延续王朝？阿森纳、利物浦能否挑战蓝月霸权？bob体育英超夺冠赔率全面解析。',
    content: `
      <p>2026-27赛季英超联赛将于8月18日重燃战火。经过夏季转会窗口的激烈争夺，各支球队的阵容都发生了显著变化。</p>
      
      <h2>争冠格局</h2>
      <p>曼城依旧是夺冠最大热门，瓜迪奥拉的球队在过去五个赛季中四次捧杯。bob体育英超夺冠赔率显示曼城以1.90位居第一，阿森纳以4.50排名第二，利物浦以5.00位列第三。</p>
      
      <p>切尔西和曼联经过重建后实力有所提升，热刺在新帅带领下也展现出不俗的状态。新赛季的英超竞争将更加激烈。</p>
      
      <p>bob体育已全面上线英超新赛季各项投注市场，包括冠军、前四、降级、最佳射手等多项玩法，赔率优势明显。</p>
    `,
    category: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=Premier%20League%20stadium%20with%20dramatic%20floodlights%2C%20professional%20soccer%20photography%2C%20premium%20sports%20aesthetic%2C%20dark%20atmosphere&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-08-01',
    readTime: '6分钟',
    tags: ['英超', '曼城', '阿森纳', '新赛季'],
  },
  {
    id: 6,
    title: 'MLB季后赛形势分析：洋基领跑美联，道奇国联称雄',
    excerpt: '2026年MLB常规赛进入冲刺阶段，季后赛席位争夺白热化。bob体育为您带来最新MLB季后赛形势分析和各队晋级赔率。',
    content: `
      <p>随着2026年MLB常规赛进入最后两个月，各支球队都在为季后赛席位奋力一搏。</p>
      
      <h2>美联形势</h2>
      <p>纽约洋基队以75胜38负的战绩领跑美联，打线火力和先发轮值均展现顶级水准。休斯顿太空人紧随其后，美联西区的竞争异常激烈。</p>
      
      <h2>国联形势</h2>
      <p>洛杉矶道奇队在国联一枝独秀，球队阵容深度令人羡慕。亚特兰大勇士队和圣迭戈教士队紧随其后。</p>
      
      <p>bob体育MLB世界大赛冠军赔率已更新，道奇以3.50位居榜首，洋基以4.20排名第二。更多MLB赛事投注尽在bob体育。</p>
    `,
    category: 'baseball',
    coverImage: 'https://readdy.ai/api/search-image?query=MLB%20baseball%20stadium%20at%20night%20with%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20premium%20aesthetic%2C%20dark%20background&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: 'bob体育编辑部',
    publishDate: '2026-07-30',
    readTime: '5分钟',
    tags: ['MLB', '洋基', '道奇', '季后赛'],
  },
];

export const getArticleById = (id: number) => articleList.find(a => a.id === id);
export const getArticlesByCategory = (slug: string) => {
  const catMap: Record<string, string> = {
    football: 'football',
    basketball: 'basketball',
    tennis: 'tennis',
    esports: 'esports',
    baseball: 'baseball',
  };
  const cat = catMap[slug] || slug;
  return articleList.filter(a => a.category === cat);
};